import { useQuery } from '@tanstack/react-query';
import {
  getAiBundle,
  listAiBundles,
  type BundleWithItems,
} from '../api/drafts';
import type { AiBundle, AiBundleStatus } from '@lognai/plugin-ai-core/src/types/bundle';
import { aiQueryKeys } from './query-keys';

export const useAiBundle = (bundleId: string | null) =>
  useQuery<BundleWithItems>({
    queryKey: bundleId ? aiQueryKeys.bundle(bundleId) : [...aiQueryKeys.all, 'bundle-null'],
    queryFn: () => getAiBundle(bundleId!),
    enabled: Boolean(bundleId),
  });

/**
 * Bundles attached to a specific thread, optionally filtered by status. Used
 * by the chat sidebar to surface a still-pending DraftBundleCard after a
 * page refresh — the SSE stream's bundleIds buffer is fresh on reload, but
 * the bundle is still alive server-side and the user needs the review card
 * to apply or reject it.
 */
const DEFAULT_ACTIVE_STATUSES: AiBundleStatus[] = [
  'pending',
  'partially_applied',
  'partially_applied_with_errors',
];

export const useAiBundlesForThread = (
  threadId: string | null,
  statuses: AiBundleStatus[] = DEFAULT_ACTIVE_STATUSES,
) =>
  useQuery<AiBundle[]>({
    queryKey: aiQueryKeys.bundles({ threadId, statuses }),
    queryFn: () => listAiBundles({ threadId: threadId!, status: statuses }),
    enabled: Boolean(threadId),
  });
